import { space } from '@repo/theme/primitives';
import { ENTITY_NODE_PADDING } from '../EntityNode/EntityNode.constants';

export const ENTITY_CHILDREN_ROW_HEIGHT = space[8];
export const ENTITY_CHILDREN_MAX_IN_VIEW = 5;
export const ENTITY_CHILDREN_MAX_HEIGHT =
	ENTITY_CHILDREN_ROW_HEIGHT * ENTITY_CHILDREN_MAX_IN_VIEW;
export const ENTITY_CHILDREN_CONTROL_HEIGHT =
	ENTITY_CHILDREN_ROW_HEIGHT + 2 * ENTITY_NODE_PADDING;
export const ENTITY_CHILDREN_SEARCH_HEIGHT =
	ENTITY_CHILDREN_ROW_HEIGHT + 2 * ENTITY_NODE_PADDING;
